import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { func, string, array } from 'prop-types';
import { required } from 'redux-form-validators';
import { Link } from 'react-router-dom';
import { Segment, Button, Form, Input, Checkbox } from 'semantic-ui-react';

import FeatureFlags from './FeatureFlags';

import Heading from '~/views/common/Heading';
import CommonForm from '~/views/common/Form';
import FormField from '~/views/common/FormField';
import Section from '~/views/common/Section';


const UserForm = ({
    submit,
    linkToView,
    feature_flags,
    ...formProps
}) => (
    <Fragment>
        <Helmet title="Edit User" />

        <Heading
            header="User"
            subheader="Edit"
            iconName="edit"
        >
            <Button
                color="green"
                icon="save"
                onClick={submit}
                content="Save"
                labelPosition="right"
            />

            <Button
                as={Link}
                to={linkToView}
                icon="cancel"
            />
        </Heading>

        <CommonForm {...formProps}>
            <Segment.Group>
                <Section name="Information">
                    <Form.Group>
                        <FormField
                            name="firstname"
                            label="First Name"
                            placeholder="First Name"
                            control={Input}
                            validate={required()}
                            required
                        />

                        <FormField
                            name="lastname"
                            label="Last Name"
                            placeholder="Last Name"
                            control={Input}
                            validate={required()}
                            required
                        />
                    </Form.Group>

                    <FormField
                        name="primary_email.email"
                        label="Email"
                        placeholder="Email"
                        control={Input}
                    />

                    <FormField
                        name="postal_code"
                        label="Postal Code"
                        placeholder="Email"
                        control={Input}
                    />

                    <FormField
                        name="gender"
                        label="Gender"
                        control={Input}
                    />
                </Section>

                <Section name="Settings">
                    <FormField control={Checkbox} toggle label="Deleted" name="deleted" />
                    <FormField control={Checkbox} toggle label="Archived" name="archived" />
                    <FormField control={Checkbox} toggle label="Wants Email" name="wants_email" />
                    <FormField control={Checkbox} toggle label="Wants Sms" name="wants_sms" />
                    <FormField control={Checkbox} toggle label="Wants Newsletter" name="wants_newsletter" />
                </Section>

                <FeatureFlags feature_flags={feature_flags} />
            </Segment.Group>
        </CommonForm>
    </Fragment>
);

UserForm.propTypes = {
    submit: func.isRequired,
    linkToView: string,
    feature_flags: array.isRequired,
};

UserForm.defaultProps = {
    linkToView: '/users',
};

export default UserForm;
